module.exports = __webpack_public_path__ + "img/ep6-7.6b90f1d5.png";